import { IBenefit } from "../../../interfaces/api";

const PPODoubleDeepInfoBenefitInOut = ({
  benefit,
  title,
  searcher,
}: {
  benefit: IBenefit[];
  title: string;
  searcher?: string;
}) => {
  return (
    <>
      <div
        className="grid-x hide-for-small-only"
        style={{
          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{ fontSize: "18px", fontWeight: 600 }}
        >
          {title}
        </div>
        <div
          className="cell small-4"
          style={{ fontSize: "18px", paddingRight: 20 }}
        >
          {benefit[0]?.pbpBenefitDesc
            ? benefit[0].pbpBenefitDesc
                .replace(/\\*\\n/g, "\n")
                .replace(/\\/g, "")
                .split("\n")
                .filter(Boolean)
                .map((line, lineIndex) => <div key={lineIndex}>{line}</div>)
            : "-"}
        </div>
        <div
          className="cell small-4"
          style={{ fontSize: "18px", paddingLeft: 20 }}
        ></div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{ fontSize: "14px", fontWeight: 600 }}
        >
          {title}
        </div>
        <div
          className="cell small-4"
          style={{ fontSize: "14px", paddingRight: 20 }}
        >
          {benefit[0]?.pbpBenefitDesc
            ? benefit[0].pbpBenefitDesc
                .replace(/\\*\\n/g, "\n")
                .replace(/\\/g, "")
                .split("\n")
                .filter(Boolean)
                .map((line, lineIndex) => <div key={lineIndex}>{line}</div>)
            : "-"}
        </div>
        <div
          className="cell small-4"
          style={{ fontSize: "14px", paddingLeft: 20 }}
        ></div>
      </div>
    </>
  );
};

export default PPODoubleDeepInfoBenefitInOut;
